var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: ['transfer-design--wrapper', 'content modal-scroll-area', {
      'hide': _vm.enableSnapShotService && !_vm.showExternalViewer
    }]
  }, [_c('p', {
    staticClass: "transfer-design--description"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.transferDesignModalDescription) + "\n  ")]), _c('div', {
    class: ['transfer-design--options-scroll', {
      'scroll-activated': _vm.isOverMaxLength
    }]
  }, [_c('div', {
    staticClass: "transfer-design--options"
  }, _vm._l(_vm.recipes, function (recipeData, modelName) {
    return _c('div', {
      key: modelName,
      class: ['transfer-design--option', {
        'selected': _vm.isSelected(modelName)
      }],
      on: {
        "click": function click($event) {
          return _vm.onSelect(modelName, recipeData);
        }
      }
    }, [_vm.enableSnapShotService ? _c('external-viewer', {
      attrs: {
        "modelName": modelName,
        "recipeData": recipeData.recipe_v2,
        "canvasWidth": "500",
        "canvasHeight": "500"
      },
      on: {
        "ready": function ready($event) {
          return _vm.updateFlags(modelName);
        }
      }
    }) : _c('div', {
      staticClass: "transfer-design--image",
      style: "background-image: url('".concat(_vm.$store.state.transferDesign.imageUrls[modelName], "')")
    }), _c('div', {
      staticClass: "transfer-design--content"
    }, [_c('p', {
      staticClass: "transfer-design--name"
    }, [_vm._v(_vm._s(recipeData.displayName))]), _c('p', {
      staticClass: "transfer-design--price"
    }, [_c('currency-wrapper', {
      attrs: {
        "priceRaw": _vm.prices[modelName]
      }
    })], 1), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: recipeData.isPersonalizationInvalid,
        expression: "recipeData.isPersonalizationInvalid"
      }],
      staticClass: "transfer-design--text"
    }, [_vm._v(_vm._s(_vm.translations.transferDesignEmbroideryText))])])], 1);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }